// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"JC-z","smallCardRow":"KC-z","largeCardRow":"LC-z","productSearchRow":"MC-z","curatedRow":"NC-z"};